// utils/removeSelectTitles.js

export function removeAntdSelectTitles() {
    function removeTitleAttribute(node) {
        if (
            node instanceof HTMLElement &&
            (node.classList.contains('ant-select-selection-item') ||
                node.classList.contains('ant-select-selection-placeholder') ||
                node.classList.contains('ant-select-item')) &&
            node.hasAttribute('title')
        ) {
            // Only remove title if text is NOT overflowing (not truncated)
            const isOverflowing = node.scrollWidth > node.clientWidth;
            if (!isOverflowing) {
                node.removeAttribute('title');
            }
        }
    }

    function removeToolTipAriaDescribedby(node) {
        if (node instanceof HTMLElement && node.hasAttribute('aria-describedby')) {
            node.removeAttribute('aria-describedby');
        }
    }

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node instanceof HTMLElement) {
                    removeTitleAttribute(node);

                    node.querySelectorAll?.(
                        '.ant-select-selection-item[title], ' +
                        '.ant-select-selection-placeholder[title], ' +
                        '.ant-select-item[title]'
                    ).forEach(removeTitleAttribute);

                    Array.from(node.querySelectorAll?.('[aria-describedby]') || [])
                        .filter(el => el.getAttribute('aria-describedby').startsWith(':'))
                        .forEach(removeToolTipAriaDescribedby);
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });

    // Remove existing ones on initial load
    document
        .querySelectorAll(
            '.ant-select-selection-item[title], ' +
            '.ant-select-selection-placeholder[title], ' +
            '.ant-select-item[title]'
        )
        .forEach(removeTitleAttribute);
}
